<template>
    <div>
        <section class="assessmentSection aocIntroSection commonlyProtectedAreasSection">
            <div class="pageContent">
                <div class="pageCompleted">70% complete</div>
                <div class="pageTitle">Get started by selecting an area that concerns you</div>
                <div class="pageText">
                    <p>
                        After learning about the room, we’ll provide you with recommendations
                    </p>
                </div>

                <div class="commonlyProtectedAreas">
                    <div v-for="area in commonlyProtectedAreas"
                         class="commonlyProtectedArea"
                         @click="selectRoom(area)">
                        <div class="commonlyProtectedArea-icon">
                            <img :src="area.image" />
                        </div>
                        <div class="commonlyProtectedArea-name">{{ area.name }}</div>
                    </div>
                </div>

            </div>
        </section>

        <section class="commonlyProtectedAreas-Footer">
            <div class="flex-container">
                <div class="flex-row">
                    <div class="helpText">
                        Or get started by searching for a specific room
                    </div>
                    <div class="helpLink">
                        <a href="javascript:;" @click="goToAocSearch">Search for a specific room <i class="fa fa-long-arrow-right" /></a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import uuid from 'uuid/v1'
export default {
    data: () => ({
        // commonlyProtectedAreas: []
    }),
    computed: {
        ...mapState(['lead', 'areaOfConcern', 'availableAreas']),

        commonlyProtectedAreas: (state) => {
            let aa = state.availableAreas
            let names = ['kitchen', 'living room', 'back porch', 'bedroom', 'foyer', 'basement']
            if (aa) {
                return aa.filter(a => names.includes(a.name.toLowerCase()))
            }
            return aa
        }
    },
    methods: {
        ...mapActions([
            'addAreaOfConcern',
            'updateAreaOfConcern',
            'incrementAocSectionIndex',
            'setAocSectionIndex',
            'handleDuplicateArea'
        ]),

        goToAocSearch() {
            this.$router.push('/assessment/areas-of-concern')
            this.setAocSectionIndex(0)
        },

        selectRoom(area) {
            mixpanel.track('selectedCommonArea', {
                "roomType": area.name
            })
            area.id = uuid()
            this.handleDuplicateArea(area).then(duplicates => {
                if (duplicates.length < 1) {
                    this.updateAreaOfConcern(area)
                    this.setAocSectionIndex(1)
                }
                this.$router.push('/assessment/areas-of-concern')
            })
        }
    },

}
</script>

<style lang="css"></style>
